export enum EventTypeEnum {
  CREATE_BIM_MODEL = "CREATE_BIM_MODEL",
  UPDATE_BIM_MODEL = "UPDATE_BIM_MODEL",
  RSEE_PROJECT_INVITATION = "RSEE_PROJECT_INVITATION",
  PROJECT_INVITATION = "PROJECT_INVITATION",
}
